import { BaseService } from '@/core/base-service';

export default class StatisticsService extends BaseService<any> {
  public constructor() {
    super('services/servicescard/api/statistics');
  }
}
